// Change nav BG on scroll
// When the user scrolls the page, execute function
window.onscroll = function() {
    colourHeader()
};

// Get the header
var header = document.getElementById("r-header");

// Get the offset position of the navbar
var sticky = header.offsetTop + 200;

// Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
function colourHeader() {
    if (window.pageYOffset > sticky) {
      header.classList.add("r-scroll");
    } else {
      header.classList.remove("r-scroll");
    }
}

var menuLists = document.getElementsByClassName('sub-nav');
var subLinks = document.querySelectorAll('.mobile-main-link');

subLinks.forEach(function(subLink) {
  subLink.addEventListener('click', function(e) {
    e.preventDefault();

    var sub = document.getElementById(e.target.dataset.sub);

    if (sub.classList.contains('open')) {
      sub.classList.remove('open');
    } else {
      Array.from(menuLists).forEach((list) => {
        list.classList.remove('open');
      });
      sub.classList.add('open');
    }
  });
});

const slideMenu = document.getElementById('mobile-menu');
const menuBtn = document.getElementById('mobile-nav');
const bodyEl = document.getElementById('body');

menuBtn.addEventListener('click', function(){
  if (menuBtn.classList.contains('open')) {
    Array.from(menuLists).forEach((list) => {
        list.classList.remove('open');
    });
    slideMenu.classList.remove('open');
    menuBtn.classList.remove('open');
    bodyEl.classList.remove('overflow-hidden', 'open');
  } else {
    slideMenu.classList.add('open');
    menuBtn.classList.add('open');
    bodyEl.classList.add('overflow-hidden', 'open');
  }
});

const scrollBtn = document.querySelector("#toTop");

const btnVisibility = () => {
  if (window.scrollY > 400) {
      scrollBtn.style.visibility = "visible";
      scrollBtn.style.opacity = "1";
  } else {
      scrollBtn.style.visibility = "hidden";
      scrollBtn.style.opacity = "0";
  }
};

document.addEventListener("scroll", () => {
  btnVisibility();
});

scrollBtn.addEventListener("click", () => {
  window.scrollTo({
      top: 0,
      behavior: "smooth"
  });
});